import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "./Legal.css";
import { useEffect } from 'react'

function Terms() {


  useEffect(() => {
   window.scrollTo(0, 0);
  }, []);
 return (
  <div className="legal-page">
   <Helmet>
    <title>Terms of Service | SportingHip</title>
    <meta
     name="description"
     content="Read the SportingHip Terms of Service."
    />
   </Helmet>

   <div className="legal-back-corner">
    <Link to="/">← Back to directory</Link>
   </div>

   <main className="legal-container legal-content-card">
    <h1 className="legal-title">Terms of Service</h1>
    <p className="legal-date">Effective date: March 4, 2026</p>

    <p>
     These Terms of Service (“Terms”) govern your use of SportingHip
     (“Services”). By using SportingHip, you agree to these Terms.
    </p>

    <h3>1. What SportingHip provides</h3>
    <p>
     SportingHip provides a sports directory that helps people discover
     local sports programs, leagues, clubs, camps, classes, tournaments,
     and organizations. SportingHip may also provide tools for sports
     organizations, including public pages, schedules, teams, standings,
     rosters, and related features.
    </p>

    <h3>2. Directory listings and accuracy</h3>
    <p>
     SportingHip may include publicly available, submitted, or manually
     researched information about organizations, programs, schedules,
     locations, fees, registration links, and other details.
    </p>

    <p>
     We do our best to keep listings clear, accurate, and up to date, but
     program details may change by season. We do not guarantee that every
     listing is complete, current, or error-free. Visitors should confirm
     details with the official organization website or contact before
     registering.
    </p>

    <h3>3. Third-party websites and registration links</h3>
    <p>
     SportingHip may link to third-party websites, registration platforms,
     social media pages, maps, or organization websites. We are not
     responsible for third-party content, availability, policies,
     registration processes, fees, or services.
    </p>

    <h3>4. Submitting updates or listing information</h3>
    <p>
     If you submit listing updates, program details, links, images, or
     other information, you represent that the information is accurate to
     the best of your knowledge and that you have the right to share it.
     We may edit, format, approve, reject, or remove submitted information
     at our discretion.
    </p>

    <h3>5. Organization pages and future tools</h3>
    <p>
     SportingHip may offer tools for organizations to manage public pages,
     schedules, teams, standings, rosters, stats, and other league-related
     information. If account-based tools are available, you are responsible
     for keeping your login information secure and for all activity under
     your account.
    </p>

    <h3>6. Acceptable use</h3>
    <ul>
     <li>No illegal activity, harassment, impersonation, or fraud</li>
     <li>No posting false, misleading, or harmful information</li>
     <li>No malware, hacking, scraping abuse, or attempts to disrupt the Services</li>
     <li>No infringement of intellectual property or privacy rights</li>
    </ul>

    <h3>7. Paid features</h3>
    <p>
     SportingHip may offer paid features, upgrades, verified listings,
     custom pages, league management tools, or other services in the
     future. Pricing, features, and availability may change. Payments may
     be processed by third-party providers.
    </p>

    <h3>8. Intellectual property</h3>
    <p>
     SportingHip, including its software, design, branding, layout, and
     original content, is owned by SportingHip or its licensors. You may
     not copy, modify, distribute, or misuse our branding or software
     without permission.
    </p>

    <h3>9. Disclaimers</h3>
    <p>
     SportingHip is provided “as is” and “as available.” We do not promise
     that the Services will always be available, uninterrupted, secure, or
     error-free. We are not responsible for program cancellations,
     inaccurate third-party information, registration issues, or changes
     made by organizations.
    </p>

    <h3>10. Limitation of liability</h3>
    <p>
     To the maximum extent allowed by law, SportingHip will not be liable
     for indirect, incidental, special, consequential, or punitive damages,
     or for loss of data, revenue, profits, goodwill, or opportunities.
    </p>

    <h3>11. Termination</h3>
    <p>
     We may suspend, restrict, or terminate access to SportingHip if we
     believe someone has violated these Terms, created risk, abused the
     Services, or provided false or harmful information.
    </p>

    <h3>12. Changes to these Terms</h3>
    <p>
     We may update these Terms from time to time. Continued use of
     SportingHip after changes means you accept the updated Terms.
    </p>

    <h3>Contact</h3>
    <p>
     Questions about these Terms? Email{" "}
     <a href="mailto:hello@sportinghip.com">hello@sportinghip.com</a>.
    </p>
   </main>
  </div>
 );
}

export default Terms;